<template>
  <button type="button" class="ui-item" :class="[tone && `ui-item--${tone}`, branch && 'ui-item--branch', { 'is-on': active }]" v-on="$listeners">
    <slot></slot>
  </button>
</template>

<script>
/** Kartica reda na telefonu (zamjena za red tabele). tone: blue | warn | bad | muted daje boju lijeve trake; branch je uvučena. */
export default {
  name: "UiItem",
  props: {
    tone: { type: String, default: "" },
    active: { type: Boolean, default: false },
    branch: { type: Boolean, default: false },
  },
};
</script>
